import React from 'react'

function AddAccount() {
  return (
    <div className='p-5'>
      AddAccount
    </div>
  )
}

export default AddAccount
